export enum InputRequirementType {
    NotRequired, Required, Optional
}